import { render } from "./BaseCard.vue?vue&type=template&id=1ecbf095&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCard.vue?vue&type=script&lang=ts"

import "./BaseCard.vue?vue&type=style&index=0&id=1ecbf095&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ecbf095"

export default script